import React from 'react';
import { Header } from './Header';
import Footer from './Footer';

import { MAX_HEADER_HEIGHT } from './Header/useHeaderHeight';

// Standalone type for StandardPage props
export interface StandardPageProps {
  children: React.ReactNode;
}

export function StandardPage({ children }: StandardPageProps) {
  return (
    <div className="bg-gray-100 font-sans min-h-screen flex flex-col">
      <Header />
      <main
        className="flex-1"
        style={{ paddingTop: MAX_HEADER_HEIGHT }}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}
